module.exports = ".attack {\n  margin-bottom: 1em;\n  background: #f5f5f5;\n  padding: 0.5em;\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 0.25em;\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n}\n.attack .desc {\n  font-size: 0.875em;\n  color: #555;\n  text-align: justify;\n}\nh3,\nh4,\nh5 {\n  margin-top: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/attacks/attack/attack.component.less
// module id = ./src/app/attacks/attack/attack.component.less
// module chunks = main